  <div class="aca-rule" [class.selected]="isSelected" >
    <div class="rule-info">
      <span class="aca-rule-title">{{rule.name}}</span>
      <p>{{rule.description}}</p>
    </div>
  </div>

